function PricingIntervalPill({ interval, selectedInterval, onClick }) {
  const isCurrentInterval = selectedInterval.toLowerCase() === interval.toLowerCase();

  return (
    <button
      type="button"
      onClick={() => onClick()}
      className={`rounded-full w-[88px] px-4 py-2 text-sm font-medium transition-colors ${
        isCurrentInterval
          ? 'bg-dodger-blue-500 text-white pointer-events-none'
          : 'text-lynch-500 hover:bg-white-lilac-500 hover:text-black-pearl-500'
      }`}
    >
      {interval}
    </button>
  );
}

export function PricingIntervalToggle({ selectedInterval, setSelectedInterval }) {
  return (
    <div className="flex justify-center mt-7">
      <div className="inline-flex rounded-full border border-mystic-500 bg-white p-1 gap-1">
        <PricingIntervalPill
          interval="Monthly"
          selectedInterval={selectedInterval}
          onClick={() => setSelectedInterval('monthly')}
        />

        <PricingIntervalPill
          interval="Yearly"
          selectedInterval={selectedInterval}
          onClick={() => setSelectedInterval('yearly')}
        />
      </div>
    </div>
  );
}
